import {
  ActivatedRouteSnapshot,
  BaseRouteReuseStrategy,
} from '@angular/router';

export class CustomRouteReuseStrategy extends BaseRouteReuseStrategy {
  /**
   * Custom route reuse strategy used to configure when the app should
   * reinitialize components
   *
   * @description
   * This method is called when the router will navigate between two routes
   * and needs to decide whether it can reuse the same component or not. By
   * default, the Angular BaseRouteReuseStrategy will take into account only
   * the route configuration, and not other data such as route parameters.
   *
   * @remarks
   * By setting the @shouldRecomputeOnParamsChange to true when defining
   * the route in the route data configuration, the router will also check
   * to see if the route parameters have changed and create a new instance
   * of that component in that case instead of using the same one
   */
  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    current: ActivatedRouteSnapshot
  ): boolean {
    // the default return value defined in the angular base route strategy implementation
    const defaultReuse = future.routeConfig === current.routeConfig;
    if (!future.routeConfig?.data?.shouldRecomputeOnParamsChange) {
      return defaultReuse;
    }

    return (
      defaultReuse &&
      JSON.stringify(future.params) === JSON.stringify(current.params)
    );
  }
}
